export default __webpack_public_path__ + "_/images/team-logo-2a02fa068186b5aafefc8ce24e9b1b58b7e31f2c5d6d6fd0798c39eaac968bca.svg";